module.exports = __webpack_public_path__ + "static/media/Mudbox.e94cc04c.png";